import {
  Guarantee,
  IntroSection,
  StoryTellingSection,
} from "../components/DownSell";
import RapidViralSecrets from "../components/DownSell/RapidViralSecrets";
import { CloseWarning } from "../components/UpSell";

const DownSellPage = () => {
  return (
    <>
      <CloseWarning />
      <IntroSection />
      <StoryTellingSection />
      <RapidViralSecrets />
      <Guarantee />
    </> 
  );
};

export default DownSellPage;
